<template>
    <div class="AddNewLocation">
        <b-form class="full-width" @submit="AddLocation">
            <b-row>
                <b-col lg="6">
                    <h2>Location Information</h2>
                    <b-form-group label="Name:">
                        <b-form-input type="text"
                                      v-model="NewLocation.Name"
                                      required
                                      autocomplete="off" />
                    </b-form-group>
                    <b-form-group label="Address:">
                        <b-row>
                            <b-col cols="8">
                                <b-form-input type="text"
                                              v-model="NewLocation.AddressLine"
                                              required
                                              autocomplete="off"
                                              placeholder="Street Address" />
                            </b-col>
                            <b-col cols="4">
                                <b-form-input type="text"
                                              v-model="NewLocation.AddressLine2"
                                              required
                                              autocomplete="off"
                                              placeholder="Apt, suite, unit, building, floor, etc." />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-input type="text"
                                              v-model="NewLocation.City"
                                              required
                                              autocomplete="off"
                                              placeholder="City" />
                            </b-col>
                            <b-col>
                                <select class="form-control" v-model="NewLocation.State" required>
                                    <option value="">Select State</option>
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </b-col>
                            <b-col>
                                <b-form-input type="text"
                                              v-model="NewLocation.Zip"
                                              required
                                              autocomplete="off"
                                              placeholder="Zip" />
                            </b-col>
                        </b-row>

                        <select class="form-control" v-model="NewLocation.County" required>
                            <option value="">Select County</option>
                            <option v-for="option in CountyOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </b-form-group>
                    <b-row>
                        <b-col>
                            <b-form-group label="Phone Number:">
                                <b-form-input type="text"
                                              v-model="NewLocation.PhoneNumber"
                                              required
                                              autocomplete="off" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="6">
                    <h2>Regional Program Enrollment</h2>
                    <b-form-group label="Regional Program">
                        <select class="form-control" v-model="NewLocation.SubProgramID" required>
                            <option v-for="option in SubProgramOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group label="Start Date">
                        <flat-pickr v-model="NewLocation.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                    </b-form-group>
                </b-col>
            </b-row>
            <button class="btn btn-success form-control" type="submit">
                <i class="fa fa-plus"></i> Add Location to Program
            </button>
        </b-form>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faRedo } from '@fortawesome/free-solid-svg-icons';
    library.add(faRedo);
    import { faRobot } from '@fortawesome/free-solid-svg-icons';
    library.add(faRobot);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMinus } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinus);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "AddNewLocation",
        data: function () {
            return {
                PageState: "Initial",
                NewLocation: {
                    Name: '',
                    AddressLine: '',
                    AddressLine2:'',
                    County: '',
                    City: '',
                    State: '',
                    Zip: '',
                    StartDate: '',
                    SubProgramID: '',
                    PhoneNumber: ''
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
            };
        },
        methods: {
            AddLocation(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "TAY/Location/AddNewLocation", this.NewLocation, this.AddLocationSuccess, this.AddLocationError, true);
            },
            AddLocationSuccess(response) {
                // switch to Locations List
                console.log("Response from adding a new Location:")
                console.log(response.data.data);
                //this.$store.commit("Teams.TeamProfiles.Append", { WrapTeam: { Id: response.data.data.WrapTeamID } });
                this.$parent.ChangePaneShown("Locations");
                // execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                // Starts a new search. Hides add to progam form and show search client form
                this.ResetPage();
            },
            AddLocationError(error) {
                console.log("Location was not created")
                console.log(error);
            },
            ResetPage() {
                this.$set(this, 'NewLocation', {
                    Name: '',
                    AddressLine: '',
                    County: '',
                    City: '',
                    State: '',
                    Zip: '',
                    StartDate: '',
                    SubProgramID: ''
                });
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
        },
        computed: {
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        }
    }
</script>

<style scoped>
</style>